module.exports = __webpack_public_path__ + "static/media/tax.1c8bf45c.svg";